import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../../models/user';
import { Role } from '../../models';
import { PAGESAccess } from '../../consts';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  public user$ = new BehaviorSubject<User | undefined>(undefined);
  public role$ = new BehaviorSubject<Role | undefined>(undefined);

  public pageAccess$ = new BehaviorSubject(PAGESAccess);
  public Breadcrumbs$ = new BehaviorSubject<Array<string>>([]);

  public onlineAnimalCardForm$ = new BehaviorSubject({
    reason: '',
    disease: '',
    treatmentId: '',
    treatment: '',
    comments: '',
  });
}
